import styled from 'styled-components';

// "⋯" overflow menu built on native <details>: keyboard accessible, no extra state.
const Details = styled.details`
  position: relative;
  display: inline-block;

  summary {
    list-style: none;
    width: 2rem;
    height: 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-accent);
    border-radius: 0.375rem;
    color: var(--text-secondary);
    cursor: pointer;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  > div {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    z-index: 10;
    min-width: 11rem;
    background: var(--surface-3);
    border: 1px solid var(--border-accent);
    border-radius: 0.5rem;
    padding: 0.375rem;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
    text-align: left;
  }

  button {
    display: block;
    width: 100%;
    padding: 0.5rem 0.625rem;
    border-radius: 0.375rem;
    font-size: 0.8125rem;
    text-align: left;
    background: transparent;
    color: var(--text-primary);
  }

  button:hover {
    background: #1f2329;
  }

  button.danger {
    color: #f07a7a;
  }
`;

const RowMenu = ({ label, items }) => (
  <Details>
    <summary aria-label={label}>⋯</summary>
    <div role="menu">
      {items.filter(Boolean).map((item) => (
        <button
          key={item.label}
          type="button"
          role="menuitem"
          className={item.danger ? 'danger' : undefined}
          onClick={(e) => {
            e.currentTarget.closest('details')?.removeAttribute('open');
            item.onClick();
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  </Details>
);

export default RowMenu;
